import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '8 4.9849'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M16 1.82986C16 1.82986 13.17 0.359863 8 0.359863C2.83 0.359863 0 1.82986 0 1.82986C0 1.82986 2.54 9.60986 8 9.60986C13.46 9.60986 16 1.82986 16 1.82986Z"
          fill={outline}
        />
        <path
          d="M16 1.7699C16 1.7699 13.17 3.16989 8 3.16989C2.83 3.16989 0 1.7699 0 1.7699C2.94 5.9299 6.12 6.7099 8 6.7099C9.88 6.7099 13.07 5.9299 16 1.7699Z"
          fill="white"
        />
      </g>
    </g>
  )
}
